<template>
  <div>
    <div v-if="classData" class="pt-2" :class="{ 'px-3': $vuetify.breakpoint.mdAndUp }">
      <Breadcrumbs
        :class="{ 'px-5 mt-2': $vuetify.breakpoint.smAndDown }"
        data="classData.title"
        :headline="classData.title"
        :link="[
          { text: 'Danh sách lớp', href: '../classes' },
          { text: classData.title, id: classData.id },
        ]"
      />

      <v-card class="mt-6">
        <v-row class="d-flex">
          <v-col class="pa-6" cols="10">
            <div class="d-flex align-end justify-space-between">
              <div>
                <div>Lớp</div>
                <h2>{{ classData.title }}</h2>
              </div>
              <div>
                <div>Học phần</div>
                <div class="font-weight-bold">
                  {{ classData.grade | getGrade }}
                </div>
              </div>
              <div>
                <div>Giáo viên phụ trách</div>
                <div class="font-weight-bold">
                  {{ getTeachers }}
                </div>
              </div>
              <div>
                <div>Môn học</div>
                <div class="font-weight-bold">{{ classData | _get('extraSubject.title', 'Không có') }}</div>
              </div>
              <div>
                <div>Sĩ số</div>
                <div class="font-weight-bold">{{ getStudentCount }}</div>
              </div>
              <div>
                <div>Trạng thái</div>
                <v-chip
                  small
                  class="white--text"
                  v-if="classData.status"
                  :color="classData.status | classStatusColor"
                  label
                >
                  {{ classData.status | classStatus }}
                </v-chip>
              </div>
            </div>
          </v-col>
          <v-col class="pa-6 d-flex justify-end align-end" cols="2">
            <v-btn @click="detailState = !detailState" small color="primary" outlined>Hồ sơ chi tiết</v-btn>
          </v-col>
        </v-row>
      </v-card>
      <ExtraClassTab class="mt-8" />
      <div class="text-center">
        <v-btn class="ma-4" @click="remove" color="red" outlined>Xóa lớp</v-btn>
      </div>
      <ExtraClassDetailDialog
        @edit="updateDialogState = !updateDialogState"
        :classData="classData"
        :state="detailState"
      />

      <ExtraClassUpdateDialog :state="updateDialogState" :classData="classInfo"></ExtraClassUpdateDialog>
    </div>
    <h1 v-else-if="!$loading.active">Class not found</h1>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { get, map, chunk } from 'lodash-es'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import ExtraClassTab from '@/modules/class/ExtraClassTab.vue'
import ExtraClassDetailDialog from '@/modules/class/ExtraClassDetailDialog.vue'
import ExtraClassUpdateDialog from '@/modules/class/ExtraClassUpdateDialog.vue'
import { Teaching } from '@/plugins/api'

export default {
  components: {
    Breadcrumbs,
    ExtraClassTab,
    ExtraClassDetailDialog,
    ExtraClassUpdateDialog,
  },
  data() {
    return {
      selectedSlot: {},
      attendanceDialogState: false,
      updateDialogState: false,
      tab: null,
      detailState: false,
      dialog: false,
    }
  },
  computed: {
    ...mapGetters('classDetail', ['classData', 'slots', 'logs', 'attendances', 'teachings', 'loading']),
    getTeachers() {
      if (this.teachings && this.teachings.length > 1) {
        let teacher = ''
        this.teachings.map((t) => {
          if (t.teacher && t.teacher.name) teacher += t.teacher.name + ', '
        })
        return teacher || 'Không có'
      } else {
        return get(this.teachings[0], 'teacher.name', 'Không có')
      }
    },
    teacherNames() {
      if (!this.classData.teachers || this.classData.teachers.length === 0) {
        return ''
      }
      return this.classData.teachers.reduce((acc, cur, idx, arr) => {
        acc += cur.name
        if (idx !== arr.length - 1) acc += ','
        return acc
      }, '')
    },
    mentorNames() {
      if (!this.classData.mentors || this.classData.mentors.length === 0) {
        return ''
      }
      return this.classData.mentors.reduce((acc, cur, idx, arr) => {
        acc += cur.name
        if (idx !== arr.length - 1) acc += ','
        return acc
      }, '')
    },
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'lg':
        case 'xl':
          return '436px'
        default:
          return '100%'
      }
    },
    teachers() {
      return []
    },
    students() {
      return []
    },
    classInfo() {
      return this.classData
    },
    classLogs() {
      return this.logs
    },
    classSlots() {
      return this.slots
    },
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'lg':
        case 'xl':
          return true
        default:
          return false
      }
    },
    getStudentCount() {
      return get(this.classData.students, 'length', 0)
    },
    getCurrentSlot() {
      const currentSlot = this.slots.filter((slot) => {
        return new Date(slot.endTime).getTime() < new Date().getTime()
      })
      return currentSlot.length
    },
    getTotalSlot() {
      return get(this.slots, 'length', 0)
    },
    getPercentageAttendance() {
      const attendanceValues = Object.values(this.attendances)
      const attendanceNum = attendanceValues.filter(
        (attendance) => attendance.status === 'attendance' || attendance.status === 'late'
      )
      return Math.floor((attendanceNum.length / attendanceValues.length) * 100)
    },
  },
  methods: {
    ...mapActions('classDetail', ['initClass', 'fetchAttendances']),
    ...mapActions('class', ['removeClass']),

    checkAttendance(selected) {
      this.selectedSlot = selected
      this.attendanceDialogState = !this.attendanceDialogState
    },
    updateClass() {
      this.updateDialogState = !this.updateDialogState
    },
    remove() {
      this.$dialog.confirm({
        title: 'Thông báo xác nhận',
        text: 'Bạn có chắc muốn xóa lớp học này? Bạn không thể hoàn tác hành động.',
        okText: 'OK',
        cancelText: 'Hủy',
        done: async () => {
          try {
            if (this.classData.students && this.classData.students.length) {
              this.$alert.error('Không thể xóa lớp đang có Học viên')
              return
            }

            this.$loading.active = true
            const teachings = await Teaching.fetch({
              class: this.classData.id,
            })
            const groups = chunk(teachings, 5)
            for (let subTeachings of groups) {
              await Promise.all(
                subTeachings.map(async (t) => {
                  return Teaching.remove(t.id)
                })
              )
            }

            await this.removeClass(this.classData.id)
            this.$alert.success('Xóa lớp học thành công!')
            this.$router.push(`/classes/`)
          } catch (error) {
            this.$alert.deleteError()
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },
  async created() {
    const classId = this.$route.params.id
    await this.initClass({ id: classId })
  },
  filters: {
    getMajorName(data) {
      return data ? data.title : ''
    },
    getRoomName(data) {
      return data ? data.title : ''
    },
    getTeacher(data) {
      if (!data || !data.length) return 'không có'
      else return map(data, 'name').join(', ')
    },
    getDivision(division) {
      if (!division) return 'không có'
      else return division.title
    },
    getGrade(grade) {
      if (grade) {
        return grade.gradeNumber
      }
      return 'Không có'
    },
  },
}
</script>
<style scoped>
.theme--light.v-tabs-items {
  background-color: transparent;
}
td {
  padding-top: 4px;
}
td:first-child {
  padding-right: 48px;
}
</style>
